export const LEGAL_PATHS = {
  hostTerms: "/legal/host-terminos-privacidad.pdf",
  privacy: "/legal/host-terminos-privacidad.pdf",
  restaurantTerms: "/legal/terminos-restaurantes.pdf",
}

export const LEGAL_LINKS = {
  host: [
    { href: LEGAL_PATHS.hostTerms, label: "Términos Tendero" },
    { href: LEGAL_PATHS.privacy, label: "Política de Privacidad" },
  ],
  resto: [
    { href: LEGAL_PATHS.restaurantTerms, label: "Términos Restaurantes" },
    { href: LEGAL_PATHS.privacy, label: "Política de Privacidad" },
  ],
}

export const LEGAL_LIBRARY = [
  { href: LEGAL_PATHS.hostTerms, label: "Términos y Privacidad Tendero" },
  { href: LEGAL_PATHS.restaurantTerms, label: "Términos Restaurantes" },
]

export const getLegalLinksForAudience = (audience = "host") =>
  LEGAL_LINKS[audience] || LEGAL_LINKS.host
